<app-header></app-header>

<div style="text-align: center; width: 100%; margin-bottom: 20px;">
  <h1 style="margin-bottom: 10px;">{{"REFERRAL.TITLE" | translate }}</h1>
  <h3>{{"REFERRAL.SUBTITLE" | translate}}</h3>


  <div class="product-container">
    <div *ngFor="let product of products" style="display: inline-block; border-radius: 10px; margin: 10px;">
      <img src="{{environment.apiUrl + (product.logoFileName || product.cleanCardImageFileName)}}" [alt]="product.name" style="width: 250px; height: 159px" />
    </div>
  </div>



</div>

<mat-card class="step-card">
  <mat-card-header>
    <mat-card-title>

    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div style="text-align: center;">

    <div>

      <div style="font-size: 1.1em; padding: 10px;">
        {{ 'REFERRAL.ENTER_MOBILE' | translate }}
      </div>

      <mat-form-field style="width: 300px;">
        <input matInput  #phoneInput type="text" [placeholder]="'ORDER.MOBILE.FORM.MOBILE' | translate" [(ngModel)]="phoneNumber" [imask]="phoneMask"
               (ngModelChange)="onPhoneNumberChange($event)"
               [unmask]="true" [disabled]="isLoading" minlength="10" maxlength="15" #phoneNumberForm="ngModel" required>
        <mat-error *ngIf="phoneNumberForm.invalid">
          {{'ORDER.FULL_NAME.FORM.REQUIRED_PHONE_FORMAT' | translate}}
        </mat-error>

      </mat-form-field>

    </div>

    <div *ngIf="vc">
      <div style="font-size: 1.1em; margin: 10px; padding: 10px; text-align: center; line-height: 1.5em; background-color: rgba(139,195,74,0.37); border-radius: 5px;">
        {{ 'REFERRAL.VOUCHER_CODE' | translate }}: <mat-icon>card_giftcard</mat-icon> {{ 'REFERRAL.VOUCHER_IS_APPLIED' | translate }}
      </div>
    </div>


    <button mat-raised-button [disabled]="isLoading" color="primary" type="submit" (click)="submitPhone();">{{'BUTTON.NEXT' | translate }}</button>

    </div>

  </mat-card-content>
  <mat-card-actions align="end">

  </mat-card-actions>
</mat-card>
